import React from 'react'

import { Tag } from 'antd'
import { HStack } from 'govwell-ui'

type Props = {
  status: string
  secondaryStatus?: string | null
}

const CSLBContractorStatusDisplay = ({ status, secondaryStatus }: Props) => {
  return (
    <HStack wrap="wrap" gap={1}>
      <Tag color={status === 'CLEAR' && !secondaryStatus ? 'green' : 'red'}>{status}</Tag>
      {secondaryStatus && <Tag color="red">{secondaryStatus}</Tag>}
    </HStack>
  )
}

export default React.memo(CSLBContractorStatusDisplay)
